module.exports = __webpack_public_path__ + "img/stackslash-35-mobile.68c4bcc9.jpg";